import { render } from "./PricesProductsStage.vue?vue&type=template&id=4744af4b"
import script from "./PricesProductsStage.vue?vue&type=script&lang=js"
export * from "./PricesProductsStage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__